import React, { Component } from "react";
import { connect } from "react-redux";
import {
  changeChkCAction,
  changeChkKAction,
  changeDsAction,
  changeNewDsAction,
} from "../redux/boring/actions";
import {
  changeBListEAction,
  changeBoringID1Action,
  changeBoringID2Action,
  changeDataAction,
  changeselMeaDataAction,
  changeSelRowAction,
  changeTListAction,
  changeYListEAction,
  changeYScaleEAction,
  regEditerAction,
  updatePompTrAction,
  updateWLTrAction,
  changeDetailCatAction,
} from "../redux/editer/actions";
import {
  openEditerAction,
  showMeaTimeEditerWindowAction,
  showDetailEditerWindowAction,
} from "../redux/ui/actions";
import Sw from "./common/Sw";
import Mea from "./editer/Mea";
import Detail from "./editer/Detail";

const mapStateToProps = (state) => {
  return {
    editerSw: state.uiReducer.editerSw,
    geoDs: state.geoReducer.dataset,
    boringDs: state.boringReducer.dataset,
    newDs: state.boringReducer.newDs,
    boringID1: state.editerReducer.boringID1,
    boringID2: state.editerReducer.boringID2,
    YScale: state.editerReducer.YScale,
    tList: state.editerReducer.tList,
    YList: state.editerReducer.YList,
    bList: state.editerReducer.bList,
    isReg: state.editerReducer.isReg,
    selRow: state.editerReducer.selRow,
    isChange: state.editerReducer.isChange,
    regNum: state.boringReducer.regNum,
    chkK: state.boringReducer.chkK,
    chkC: state.boringReducer.chkC,
    meaTimeEditerWindowVisible: state.uiReducer.meaTimeEditerWindowVisible,
    selMeaData: state.editerReducer.selMeaData,
    wlTrData: state.editerReducer.editerWlMeaData,
    pompTrData: state.editerReducer.editerPompMeaData,
    detailEditerWindowVisible: state.uiReducer.detailEditerWindowVisible,
    detailCat: state.editerReducer.detailCat,
    geoDs: state.geoReducer.dataset,
  };
};

class Main extends Component {
  constructor(props) {
    super(props);
    this.scaleWidth = 15; //1目盛 = 15px
    this.maxY = null;
    this.YScale = null;
    this.thkList = [];
    this.YList = [];
    this.boring = null;
    this.boringID1 = this.props.boringID1;
    this.boringID2 = this.props.boringID2;
    this.sameCoordID = null;

    this.createEditer = this.createEditer.bind(this);
    this.createDiag = this.createDiag.bind(this);
    this.changeYScale = this.changeYScale.bind(this);
    this.changeGeo = this.changeGeo.bind(this);
    this.changeGeoIndex = this.changeGeoIndex.bind(this);
    this.changeRow = this.changeRow.bind(this);
    this.doOK = this.doOK.bind(this);
    this.closeSw = this.closeSw.bind(this);
    this.openMeaDataSw = this.openMeaDataSw.bind(this);
    this.initMeaData = this.initMeaData.bind(this);

    this.tbRef = React.createRef();
    this.$hoverCell = null;

    this.props.dispatch(changeSelRowAction(null));
    this.createEditer(this.boringID1, this.boringID2, null);
    this.initMeaData();
    //this.screenInvisible();
  }

  componentDidUpdate(prevProps) {
    if (this.props.boringID1 == null || this.props.boringID2 == null) {
      return;
    }
    /*
     * 選択ボーリング変更
     * @since hara 2020-09-09
     */
    if (
      prevProps.boringID1 !== this.props.boringID1 ||
      prevProps.boringID2 !== this.props.boringID2
    ) {
      //直前のデータを保存する

      //行選択解除
      this.tbRef.childNodes.forEach((el) => {
        el.classList.remove("selRow");
      });
      this.props.dispatch(changeSelRowAction(null));

      this.boringID1 = this.props.boringID1;
      this.boringID2 = this.props.boringID2;

      this.props.dispatch(showMeaTimeEditerWindowAction(false));

      this.createEditer(this.boringID1, this.boringID2, null);
    }

    /*
     * エディタ更新
     * @since hara 2020-09-09
     */
    if (prevProps.newDs !== this.props.newDs && this.props.isChange) {
      //初期と入力値変更時
      if (this.boring !== null && !this.boring.geo.length)
        //geoが空の場合、行選択解除
        this.props.dispatch(changeSelRowAction(null));

      this.props.dispatch(changeDataAction(false));
      this.createEditer(this.boringID1, this.boringID2, null);
    }

    /*
     * 登録OK
     * @since hara 2020-10-09
     */
    if (prevProps.boringDs !== this.props.boringDs) {
      //this.closeSw();
    }

    /*
     * 登録OK（描画時に閉じる場合）
     * @since hara 2020-10-23
     */
    if (prevProps.isReg !== this.props.isReg) {
      if (this.props.isReg) {
        this.doOK();
      } else if (!this.props.isReg) {
        this.closeSw();
      }

      this.props.dispatch(regEditerAction(null));
    }
  }

  /*
   * エディタ作成
   * @param {String} ID1 ボーリングID1
   * @param {String} ID2 ボーリングID2
   * @param {String} selVal 選択された値(初期表示の場合はnull)
   * @since hara 2020-09-09
   */
  createEditer(ID1, ID2, selVal) {
    this.boring = this.props.newDs[ID1].data[ID2];
    this.sameCoordID = window.getSameCoordID(this.boring.lon, this.boring.lat);
    const ds = [...this.props.newDs];

    if (1 < this.sameCoordID.length) {
      //同地点に複数ボーリングが存在する場合
      let firstCoordID;
      if (ID1 == this.props.regNum) {
        firstCoordID = this.sameCoordID[0].split("_");
      } else {
        firstCoordID = this.sameCoordID[this.sameCoordID.length - 1].split("_");
      }

      let ID = firstCoordID;

      this.sameCoordID.forEach((el) => {
        const elID = el.split("_");

        if (selVal === null) {
          //初期表示
          if (ds[elID[0]].data[elID[1]].sel !== undefined) {
            //selプロパティーがある場合
            ID = elID;
          }
        } else {
          //選択した場合
          this.props.dispatch(showDetailEditerWindowAction(false));
          if (selVal === el) {
            //選択値と同じ場合selプロパティー追加
            const data = ds[elID[0]].data[elID[1]];
            data.sel = true;
            ID = elID;
          } else {
            //選択値と異なる場合selプロパティー削除
            delete ds[elID[0]].data[elID[1]].sel;
          }
        }
      });

      this.boringID1 = ID[0];
      this.boringID2 = ID[1];
      this.boring = this.props.newDs[this.boringID1].data[this.boringID2];

      this.props.dispatch(changeBoringID1Action(this.boringID1));
      this.props.dispatch(changeBoringID2Action(this.boringID2));
      this.props.dispatch(changeNewDsAction(ds));
    }

    this.createTable();
    this.createDiag(1);
  }

  /*
   * テーブル作成
   * @since hara 2020-10-07
   */
  async createTable() {
    this.thkList = [];
    let tList = [];
    let preDepThk = 0;

    if (this.boring.con === undefined) {
      this.boring.con = [];
    }
    if (this.boring.geo.length) {
      //geoが空でない場合
      const allGeos = this.props.geoDs.flatMap((ds) => ds.geo);
      await this.boring.geo.forEach(async (el, index) => {
        let sel;
        let depTd;
        let thkTd;
        let scrTd;
        let conTd;
        var geoDs = JSON.parse(JSON.stringify(this.props.geoDs));
        sel = allGeos.find((item) => item.ID === el[1]);
        let thk;
        if (this.props.newDs[this.boringID1].depThkRdo === "dep") {
          //深度の場合
          thk = el[0] - preDepThk;
          //depTd = <input className='textT l-textR' value={(el[0]).toFixed(2)} onChange={e => this.changeField(index, 0, e)} />;/*★公開版で削除 下のコメント解除*/
          depTd = <p className="l-textR">{el[0].toFixed(2)}</p>;
          thkTd = <p className="l-textR">{Math.abs(thk).toFixed(2)}</p>;

          preDepThk = el[0];
        } else {
          //層厚の場合
          thk = el[0];
          depTd = (
            <p className="l-textR">{Math.abs(el[0] + preDepThk).toFixed(2)}</p>
          );
          //thkTd = <input className='textT l-textR' value={(thk).toFixed(2)} onChange={e => this.changeField(index, 0, e)} />;/*★公開版で削除 下のコメント解除*/
          thkTd = <p className="l-textR">{thk.toFixed(2)}</p>;

          preDepThk += el[0];
        }

        scrTd = this.boring.screen[index][0];

        if (this.boring.con[index] === undefined) {
          this.boring.con[index] = [];
          this.boring.con[index][0] = 0.0;
          this.boring.con[index][1] = false;
          this.boring.con[index][2] = 0.0;
          this.boring.con[index][3] = 0.0;
          conTd = false;
        } else {
          conTd = this.boring.con[index][1];
        }

        this.thkList.push([thk, el[1], this.boring.screen[index]]);
        tList.push(
          <tr id={index} key={index} onClick={this.changeRow}>
            <td>{sel.ID}</td>
            <td>
              {/*★ここから公開版で削除*/}
              {/*
                            <select className='selectT' value={sel.ID} onChange={e => this.changeField(index, 1,  e)}>
                                {this.props.geoDs[0].geo.map(el => (
                                    <option value={el.ID} key={el.ID}>{el.name}</option>
                                ))}
                            </select>
                            */}
              {/*★ここまで公開版で削除 下のコメント解除*/}
              {/*
                            <p>{this.props.geoDs[0].geo[sel.ID - 1].name}</p>
                            */}
              <p>{sel.name}</p>
            </td>
            <td style={{ backgroundColor: sel.color }}></td>
            <td>{depTd}</td>
            <td>{thkTd}</td>
            <td className="scrCheck">
              <input
                type="checkbox"
                id={"scr" + index}
                name={index}
                value={index}
                onChange={(e) => this.hglCell(e, index)}
                checked={scrTd}
              />
            </td>
            <td
              contenteditable="true"
              className="hidden l-textR"
              id={"unit_weight" + index}
            >
              {this.boring.con[index][0].toFixed(2)}
            </td>
            <td className="conCheck hidden">
              <input
                type="checkbox"
                id={"con" + index}
                name={index}
                value={index}
                onChange={(e) => this.hglCell(e, index)}
                checked={conTd}
              />
            </td>
            <td
              className={conTd ? "l-textR" : "disabled hidden l-textR"}
              id={"coeff" + index}
              onBlur={(e) => this.editChell(e, index)}
            >
              {this.boring.con[index][2].toFixed(2)}
            </td>
            <td
              className={conTd ? "l-textR" : "disabled hidden l-textR"}
              id={"void_ratio" + index}
              onBlur={(e) => this.editChell(e, index)}
            >
              {this.boring.con[index][3].toFixed(2)}{" "}
            </td>
          </tr>
        );
      });
    }
    this.props.dispatch(changeTListAction(tList));
    if (this.props.chkC !== undefined && this.props.chkC !== null) {
      if (this.boring === this.props.chkC[2]) {
        this.checkbox_cell(1);
      } else {
        this.checkbox_cell(0);
      }
    } else {
      this.checkbox_cell(0);
    }
  }

  /*
   * フィールド変更
   * @param {Number} rowIndex フィールドの行インデックス
   * @param {Number} geoIndex 0=深度・層厚/1=地質カラーID
   * @param {Event} e イベント情報
   * @since hara 2020-10-07
   */
  changeField(rowIndex, geoIndex, e) {
    const ds = [...this.props.newDs];
    ds[this.boringID1].data[this.boringID2].geo[rowIndex][geoIndex] =
      parseFloat(e.target.value);

    this.props.dispatch(changeNewDsAction(ds));
    this.props.dispatch(changeDataAction(true));
  }

  /*
   * 透水係数最適化解析使用フラグのオンオフ
   * @param {Event} e イベント情報
   * @since ando 2024-10-18
   */
  changeKCheck(e) {
    if (this.props.chkK !== undefined && this.props.chkK !== null) {
      if (this.boring === this.props.chkK[2]) {
        this.props.dispatch(changeChkKAction(null));
        this.checkbox_cell(0);
      } else {
        this.props.dispatch(
          changeChkKAction([
            this.props.boringID1,
            this.props.boringID2,
            this.boring,
          ])
        );
        this.props.dispatch(changeChkCAction(null));
        this.checkbox_cell(0);
      }
    } else {
      this.props.dispatch(
        changeChkKAction([
          this.props.boringID1,
          this.props.boringID2,
          this.boring,
        ])
      );
      this.props.dispatch(changeChkCAction(null));
      this.checkbox_cell(0);
    }
  }

  /*
   * 圧密解析使用フラグのオンオフ
   * @param {Event} e イベント情報
   * @since ando 2024-10-18
   */
  changeCCheck(e) {
    if (this.props.chkC !== undefined && this.props.chkC !== null) {
      if (this.boring === this.props.chkC[2]) {
        this.props.dispatch(changeChkCAction(null));
        this.checkbox_cell(0);
      } else {
        this.props.dispatch(
          changeChkCAction([
            this.props.boringID1,
            this.props.boringID2,
            this.boring,
          ])
        );
        this.props.dispatch(changeChkKAction(null));
        this.checkbox_cell(1);
      }
    } else {
      this.props.dispatch(
        changeChkCAction([
          this.props.boringID1,
          this.props.boringID2,
          this.boring,
        ])
      );
      this.props.dispatch(changeChkKAction(null));
      this.checkbox_cell(1);
    }
  }

  /*
   * ウィンドウオープン時透水係数最適化解析使用フラグがオンかオフのチェック
   * @param {Event} e イベント情報
   * @since ando 2024-10-18
   */
  checkKCheck() {
    if (this.props.chkK != undefined) {
      if (this.boring == this.props.chkK[2]) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  /*
   * ウィンドウオープン時圧密計算フラグがオンかオフかのチェック
   * @param {Event} e イベント情報
   * @since sangenya 2025-1-10
   */
  checkCCheck() {
    if (this.props.chkC != undefined) {
      if (this.boring == this.props.chkC[2]) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  /*
   * 計測データの初期化
   * @since ando 2024-12-5
   */
  initMeaData() {
    if (!this.props.wlTrData[this.props.boringID1]) {
      this.props.wlTrData[this.props.boringID1] = {};
    }

    if (!this.props.wlTrData[this.props.boringID1][this.props.boringID2]) {
      this.props.wlTrData[this.props.boringID1][this.props.boringID2] = [];
    }
    this.props.dispatch(updateWLTrAction(this.props.wlTrData));

    if (!this.props.pompTrData[this.props.boringID1]) {
      this.props.pompTrData[this.props.boringID1] = {};
    }

    if (!this.props.pompTrData[this.props.boringID1][this.props.boringID2]) {
      this.props.pompTrData[this.props.boringID1][this.props.boringID2] = [];
    }
    this.props.dispatch(updatePompTrAction(this.props.pompTrData));
  }

  /*
   * セルハイライト
   * @param {Event} e イベント情報
   * @param {String} num IDの番号
   * @since hara 2021-02-25
   */
  hglCell(e, num) {
    const ds = [...this.props.newDs];

    if (e.target.id.match(/scr/)) {
      ds[this.boringID1].data[this.boringID2].screen[num][0] = e.target.checked;
    }
    if (e.target.id.match(/con/)) {
      ds[this.boringID1].data[this.boringID2].con[num][1] = e.target.checked;
      const coeff = document.getElementById("coeff" + num);
      const void_ratio = document.getElementById("void_ratio" + num);
      coeff.contentEditable = e.target.checked.toString();
      void_ratio.contentEditable = e.target.checked.toString();
      if (e.target.checked) {
        coeff.classList.remove("disabled");
        void_ratio.classList.remove("disabled");
      } else {
        coeff.className = "disabled " + coeff.className;
        void_ratio.className = "disabled " + void_ratio.className;
      }
    }

    this.props.dispatch(changeNewDsAction(ds));
    this.props.dispatch(changeDataAction(true));
    this.forceUpdate();
    this.createTable();
  }

  /*
   * 入力データに応じてデータセットを更新
   * @param {Event} e イベント情報
   * @param {String} num IDの番号
   * @since sangenya 2025-02-07
   */
  editChell(e, num) {
    const data = parseFloat(
      document.getElementById(e.target.id).childNodes[0].data
    );
    const ds = [...this.props.newDs];

    if (e.target.id.match(/coeff/)) {
      if (isNaN(data)) {
        data = ds[this.boringID1].data[this.boringID2].con[num][2];
      } else {
        ds[this.boringID1].data[this.boringID2].con[num][2] = data;
      }
    }
    if (e.target.id.match(/void_ratio/)) {
      if (isNaN(data)) {
        data = ds[this.boringID1].data[this.boringID2].con[num][3];
      } else {
        ds[this.boringID1].data[this.boringID2].con[num][3] = data;
      }
    }

    this.props.dispatch(changeNewDsAction(ds));
    this.props.dispatch(changeDataAction(true));
    this.forceUpdate();
    this.createTable();
  }

  /*
   * 図作成
   * @param {Boolean} isInit true=初期値による表示/false=入力値による表示
   * @since hara 2020-09-09
   */
  createDiag(isInit) {
    this.YList = [];
    let bList = null;
    const allGeos = this.props.geoDs.flatMap((ds) => ds.geo);
    if (this.boring.geo.length) {
      //geoが空でない場合
      this.setScale(isInit);

      const createBoring = () => {
        let li = [];
        this.thkList.forEach((el, index) => {
          var sel;
          let geoDsID = 0;
          sel = allGeos.find((item) => item.ID === el[1]);

          li.push(
            <li
              style={{
                backgroundColor: sel.color,
                height: (el[0] * this.scaleWidth) / this.YScale + "px",
              }}
              key={index}
              id={"boringEdiCell_" + index}
              className={el[2][0] === true ? "cellClick" : ""}
            >
              <div
                className="Boring__wl"
                style={{ top: (el[0] * this.scaleWidth) / this.YScale + "px" }}
              ></div>
            </li>
          );
        });
        return li;
      };

      const drawWl = this.boring.GL - this.boring.WL;
      //地下水位取得
      const getWl = () => {
        if (
          drawWl <= this.maxY &&
          this.boring.WL !== undefined &&
          this.boring.WL !== null
        ) {
          let top = (drawWl * this.scaleWidth) / this.YScale;
          //2 = borderの太さ（border-bottom4px）の半分2px
          top = top - 2;
          return (
            <li className="EditerLgd__wl" style={{ top: top + "px" }}></li>
          );
        } else {
          return null;
        }
      };
      bList = (
        <ul className="EditerLgd__main">
          {createBoring()}
          {getWl()}
        </ul>
      );

      this.createScale(this.YScale, this.maxY);
    }

    this.props.dispatch(changeYScaleEAction(this.YScale));
    this.props.dispatch(changeYListEAction(this.YList));
    this.props.dispatch(changeBListEAction(bList));
  }

  /*
   * 目盛設定
   * @param {Boolean} isInit 0=初期化/1=初期値による表示/2=入力値による表示
   * @since hara 2020-09-09
   */
  setScale(isInit) {
    /*
     * Y軸目盛最大値計算
     * return {Boolean} this.maxY Y軸目盛最大値
     * @since hara 2020-09-09
     */
    const calcMaxY = () => {
      this.maxY = 0;
      this.thkList.forEach((el) => {
        this.maxY += el[0];
      });

      return this.maxY;
    };
    const root = 16; //rootのフォントサイズ(商用版ではディスプレイサイズによって可変とする)
    const dspH = (24 - 1.2) * root; //24=height24 1.2=padding0.6
    let YScaleNum = Math.floor(dspH / this.scaleWidth);
    switch (isInit) {
      case 0:
        this.YScale = Math.ceil((calcMaxY() / YScaleNum) * 10) / 10;
        this.boring.YScale = undefined;
        break;
      case 1:
        this.YScale = Math.ceil((calcMaxY() / YScaleNum) * 10) / 10;
        if (this.boring.YScale != undefined) {
          if (this.YScale != this.boring.YScale) {
            //YScaseleが初期値から変わっていたら
            this.YScale = this.boring.YScale;
          }
        }
        break;
      case 2:
        if (0.5 <= this.props.YScale) {
          this.YScale = this.props.YScale;
          this.boring.YScale = this.props.YScale;
        }
        break;
    }
    if (this.YScale < 0.5) {
      //目盛が0.5以下の場合
      this.YScale = 0.5;
    }
  }

  /*
   * 目盛作成
   * @param {Number} scale 1目盛値
   * @param {Boolean} max 目盛最大値
   * @since hara 2020-09-09
   */
  createScale(scale, max) {
    const num = Math.ceil(max / scale);
    for (let i = 1; i <= num; i++) {
      this.YList.push(
        <li className="scaleY--editer" key={i}>
          {(scale * i).toFixed(window.getDecDig(scale))}
        </li>
      );
    }
  }

  /*
   * チェックボックスの状態に応じてテーブルを変形する
   *
   * @since sangenya 2024-01-10
   */
  checkbox_cell(mode) {
    var TABLE = document.getElementById("testTbl");
    if (!TABLE) return;

    var div = TABLE.parentNode;
    var rows = Array.from(TABLE.rows);

    // 各セルインデックスの取得
    var unightweight = document.getElementById("editor_unitweight");
    var ratio = document.getElementById("editor_ratio");
    var con = document.getElementById("editor_consolidation");
    var coeff = document.getElementById("editor_coeff");

    // セルが取得できない場合は中断
    if (!unightweight || !ratio || !con || !coeff) return;

    var unightweight_cell_index = unightweight.cellIndex;
    var ratio_cell_index = ratio.cellIndex;
    var con_cell_index = con.cellIndex;
    var coeff_cell_index = coeff.cellIndex;

    let set = (c) => {
      rows.forEach((row, i) => {
        // セルが存在するか安全に確認
        if (!row || !row.cells) return;

        const uw = row.cells[unightweight_cell_index];
        const rc = row.cells[ratio_cell_index];
        const cc = row.cells[con_cell_index];
        const co = row.cells[coeff_cell_index];

        if (uw && uw.classList) uw.classList.toggle("hidden", !c);
        if (rc && rc.classList) rc.classList.toggle("hidden", !c);
        if (cc && cc.classList) cc.classList.toggle("hidden", !c);
        if (co && co.classList) co.classList.toggle("hidden", !c);
      });

      // divにクラスを付ける
      if (div && div.classList) {
        div.classList.toggle("Editor_con", c);
      }
    };

    set(mode === 1);
  }

  /*
   * 地質変更
   * @param {Number} cat 0=地質挿入/ 1=地質追加/ 2=地質削除
   * @since hara 2020-09-09
   */
  changeGeo(cat) {
    if (cat !== 1 && this.props.selRow === null)
      //選択行がない場合
      return;

    const ds = [...this.props.newDs];
    const geo = ds[this.boringID1].data[this.boringID2].geo;

    switch (cat) {
      case 0:
        geo.splice(this.props.selRow, 0, [0, 1]);
        break;
      case 1:
        geo.push([0, 1]);
        break;
      case 2:
        geo.splice(this.props.selRow, 1);

        //最後の行を削除した場合前の行に選択を移す
        const trs = this.tbRef.childNodes;
        const rowNum = trs.length - 1;
        if (this.props.selRow !== 0 && this.props.selRow === rowNum)
          trs[rowNum - 1].click();

        break;
    }

    this.props.dispatch(changeNewDsAction(ds));
    this.props.dispatch(changeDataAction(true));
  }

  /*
   * 地質インデックス変更
   * @param {Number} cat 0=上/ 1=下
   * @since hara 2020-10-08
   */
  changeGeoIndex(cat) {
    if (this.props.selRow === null)
      //選択行がない場合
      return;

    const index = cat === 0 ? this.props.selRow - 1 : this.props.selRow;
    const ds = [...this.props.newDs];
    const geo = ds[this.boringID1].data[this.boringID2].geo;

    if (cat === 0 ? index !== -1 : index < geo.length - 1) {
      geo.splice(index, 2, geo[index + 1], geo[index]);

      //選択行を移動
      const newSelRow = cat === 0 ? index : index + 1;
      this.tbRef.childNodes[newSelRow].click();

      this.props.dispatch(changeNewDsAction(ds));
      this.props.dispatch(changeDataAction(true));
    }
  }

  /*
   * 標尺(Y軸)入力変更
   * @param {Event} e イベント情報
   * @since hara 2020-09-09
   */
  changeYScale(e) {
    this.props.dispatch(changeYScaleEAction(e.target.value));
  }

  /*
   * テーブル選択
   * @param {Event} e イベント情報
   * @since hara 2020-10-08
   */
  changeRow(e) {
    e.target.closest("tbody").childNodes.forEach((el) => {
      el.classList.remove("selRow");
    });
    const tr = e.target.closest("tr");
    tr.classList.add("selRow");

    this.props.dispatch(changeSelRowAction(parseInt(tr.id)));
  }

  /*
   * スクリーン位置列表示非表示
   * @since ando 2023-08-25
   */
  screenInvisible() {
    let tbl = document.getElementById("testTbl");
    tbl.style.display = "none";
  }

  /*
   * 登録OK
   * @since hara 2020-10-09
   */
  doOK() {
    /*
     * 入力値確認
     */
    const newDs = this.props.newDs[this.boringID1];
    if (newDs.depThkRdo === "dep") {
      const geo = newDs.data[this.boringID2].geo;
      let depFlg = false;
      let preDep = 0;

      for (let i = 0; i < geo.length; i++) {
        const dep = geo[i][0];
        if (dep <= preDep) {
          //現在の深度が1つ前の深度より小さい場合アラート表示
          depFlg = true;
          break;
        }
        preDep = dep;
      }

      if (depFlg) {
        alert("深度が不正です。");
        return;
      }
    }

    this.props.dispatch(changeDsAction(this.props.newDs[this.boringID1]));
  }

  /*
   * サブウィンドウを閉じる
   * @since hara 2020-09-09
   */
  closeSw() {
    window.dehglClkBoring();
    //GM-WELLで作成したボーリング、最適化に使用するボーリングの場合キャプチャをとる。
    if (this.props.chkK != undefined) {
      if (this.boring == this.props.chkK[2]) {
        window.captureBorEditor();
      }
    }
    if (this.props.newDs[this.boringID1].name == "Analysis") {
      window.captureBorEditor();
    }
    this.props.dispatch(showMeaTimeEditerWindowAction(false));
    this.props.dispatch(changeDsAction(this.props.newDs[this.boringID1]));
    this.props.dispatch(openEditerAction(null));
  }

  /*
   * 計測データウィンドウを開く
   * @since ando 2024-12-05
   */
  openMeaDataSw(cat) {
    if (cat == 2) {
      this.props.dispatch(changeDetailCatAction(0));
      if (this.props.detailEditerWindowVisible) {
        this.props.dispatch(showDetailEditerWindowAction(false));
        this.props.dispatch(showDetailEditerWindowAction(true));
      } else {
        this.props.dispatch(showDetailEditerWindowAction(true));
      }
    } else {
      this.props.dispatch(changeselMeaDataAction(cat));
      if (this.props.meaTimeEditerWindowVisible) {
        this.props.dispatch(showMeaTimeEditerWindowAction(false));
        this.props.dispatch(showMeaTimeEditerWindowAction(true));
      } else {
        this.props.dispatch(showMeaTimeEditerWindowAction(true));
      }
      console.log("******");
      console.log(this.props.selMeaData);
    }
  }

  render() {
    return (
      <div>
        {this.props.editerSw ? (
          <Sw title="ボーリングエディタ" focusName="editer">
            <div className="Editer_wrap l-flex">
              <div>
                {1 < this.sameCoordID.length && (
                  <div className="l-row">
                    <label>ボーリング：</label>
                    <select
                      className="selectL"
                      value={this.boringID1 + "_" + this.boringID2}
                      onChange={(e) =>
                        this.createEditer(
                          e.target.value.split("_")[0],
                          e.target.value.split("_")[1],
                          e.target.value
                        )
                      }
                    >
                      {this.sameCoordID.map((el) => (
                        <option value={el} key={el}>
                          {this.props.newDs[el.split("_")[0]].name +
                            " - " +
                            this.props.newDs[el.split("_")[0]].data[
                              el.split("_")[1]
                            ].ido_ID}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                <div
                  className={
                    1 < this.sameCoordID.length ? "l-row l-mtS" : "l-row"
                  }
                >
                  <label>名称：</label>
                  <div
                    className="color2"
                    style={{
                      backgroundColor: this.props.newDs[this.boringID1].color,
                    }}
                  ></div>
                  <p>{this.props.newDs[this.boringID1].name}</p>
                  <label className="l-blank">ID：</label>
                  <p>{this.boring.ido_ID}</p>
                </div>

                <div className="l-row l-mtS">
                  <label>緯度：</label>
                  <p>{this.boring.lat.toFixed(5)}</p>
                  <label className="l-blank">経度：</label>
                  <p>{this.boring.lon.toFixed(5)}</p>
                  <label className="l-blank">孔口標高：</label>
                  <p>
                    {this.boring.GL === undefined || this.boring.GL === null
                      ? "-"
                      : this.boring.GL.toFixed(1)}
                  </p>
                  <label className="l-blank">地下水標高：</label>
                  <p>
                    {this.boring.WL === undefined || this.boring.WL === null
                      ? "-"
                      : this.boring.WL.toFixed(1)}
                  </p>
                  {/*
                                    <label className='l-blank'><button className='sBtn' onClick={() => this.openMeaDataSw(0)}>水位データ</button></label>
                                    <label className='l-blank'><button className='sBtn' onClick={() => this.openMeaDataSw(1)}>揚水データ</button></label>
                                    */}
                  <label className="l-blank">
                    <button
                      className="sBtn"
                      onClick={() => this.openMeaDataSw(2)}
                    >
                      詳細情報
                    </button>
                  </label>
                </div>

                <fieldset className="Unit l-mtS">
                  <div className="btnWrap">
                    {/*★ここから公開版で削除*/}
                    {/*
                                        <button className='sBtn' onClick={() => this.changeGeo(0)}>挿入</button>
                                        <button className='sBtn l-mlS' onClick={() => this.changeGeo(1)}>追加</button>
                                        <button className='sBtn l-mlS' onClick={() => this.changeGeo(2)}>削除</button>
                                        <button className='sBtn l-mlS' onClick={() => this.changeGeoIndex(0)}>上</button>
                                        <button className='sBtn l-mlS' onClick={() => this.changeGeoIndex(1)}>下</button>
                                        <div className='dividerV'></div>
                                        */}
                    {/*★ここまで公開版で削除*/}
                    <label>標尺 (Y軸)：</label>
                    <input
                      className="textS"
                      type="text"
                      value={this.props.YScale == null ? 0 : this.props.YScale}
                      onChange={this.changeYScale}
                    />
                    <button
                      className="sBtn l-mlS"
                      onClick={() => this.createDiag(2)}
                    >
                      適用
                    </button>
                    <button
                      className="sBtn l-mlS"
                      onClick={() => this.createDiag(0)}
                    >
                      初期値
                    </button>
                  </div>

                  <div className="l-flex l-mtS">
                    {/* <div className='EditerTWrap' style={{ overflowY: 'scroll' }}>
                                            <table className='table' id='testTbl'>
                                                <thead>
                                                    <tr>
                                                        <th className='tsS'>地質ID</th>
                                                        <th className='tsM'>地質名称</th>
                                                        <th className='tsS'>地質カラー</th>
                                                        <th className='tsS'>深度</th>
                                                        <th className='tsS'>層厚</th>
                                                        <th className='tsS'>スクリーン</th>
                                                    </tr>
                                                </thead>
                                                <tbody ref={ref => this.tbRef = ref}>{this.props.tList}</tbody>
                                            </table>
                                        </div> */}
                    <div
                      className="EditerTWrap"
                      style={{ overflowY: "scroll" }}
                    >
                      <table className="table" id="testTbl">
                        <thead>
                          <tr>
                            <th className="tsS">地質ID</th>
                            <th className="tsM">地質名称</th>
                            <th className="tsS">地質カラー</th>
                            <th className="tsSM">深度</th>
                            <th className="tsSM">層厚</th>
                            <th id="editor_screen" className="tsS">
                              スクリーン
                            </th>
                            <th id="editor_unitweight" className="tsSM hidden">
                              単位体積重量
                            </th>
                            <th
                              id="editor_consolidation"
                              className="tsS hidden"
                            >
                              圧密
                            </th>
                            <th id="editor_coeff" className="tsSM hidden">
                              圧縮係数
                            </th>
                            <th id="editor_ratio" className="tsSM hidden">
                              間隙比
                            </th>
                          </tr>
                        </thead>
                        <tbody ref={(ref) => (this.tbRef = ref)}>
                          {this.props.tList}
                        </tbody>
                      </table>
                    </div>
                    <div className="EditerLgd l-mlM">
                      <ul className="EditerLgd__y">{this.props.YList}</ul>
                      {this.props.bList}
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>

            <div>
              <div className="l-right l-mtM">
                {/*<button className='cBtn' onClick={this.doOK}>OK</button>*/}
                {/*★公開版で削除*/}
                <fieldset class="l-left no-border">
                  <legend className="kCheck">
                    <input
                      type="checkbox"
                      id="kCheck"
                      name="1"
                      className="check"
                      onChange={(e) => this.changeKCheck(e)}
                      checked={this.checkKCheck()}
                    />
                    <label htmlFor="kCheck"></label>&nbsp;最適化計算に使用する
                    <input
                      type="checkbox"
                      id="cCheck"
                      name="1"
                      className="check"
                      onChange={(e) => this.changeCCheck(e)}
                      checked={this.checkCCheck()}
                    />
                    <label htmlFor="cCheck"></label>&nbsp;圧密計算に利用する
                  </legend>
                </fieldset>
                <button className="cBtn l-mlS" onClick={this.closeSw}>
                  閉じる
                </button>
                {/*★公開版で名称を閉じるに変更*/}
              </div>
            </div>
          </Sw>
        ) : null}
        {this.props.meaTimeEditerWindowVisible ? <Mea /> : null}
        {this.props.detailEditerWindowVisible && this.props.detailCat == 0 ? (
          <Detail />
        ) : null}
      </div>
    );
  }
}

export default connect(mapStateToProps)(Main);
